import {Check} from 'lucide-react';
import {RadioGroup as RadioGroupPrimitive} from 'radix-ui';
import * as React from 'react';

import {cn} from '@/utils/ui';

const ColorPicker = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  Omit<
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>,
    'children'
  > & {colors: string[]}
>(({colors, className, ...props}, ref) => (
  <RadioGroupPrimitive.Root
    ref={ref}
    className={cn('flex flex-wrap gap-2', className)}
    {...props}
  >
    {colors.map(color => (
      <ColorPickerItem key={color} color={color} />
    ))}
  </RadioGroupPrimitive.Root>
));
ColorPicker.displayName = 'ColorPicker';

const ColorPickerItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  {color: string}
>(({color}, ref) => (
  <RadioGroupPrimitive.Item
    ref={ref}
    value={color}
    aria-label={color}
    style={{backgroundColor: color}}
    className={cn(
      'flex size-8 items-center justify-center rounded-full border border-black/10',
      'transition-transform hover:scale-110',
      'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none',
      'disabled:cursor-not-allowed disabled:opacity-50'
    )}
  >
    <RadioGroupPrimitive.Indicator>
      <Check className="size-4 text-white drop-shadow" />
    </RadioGroupPrimitive.Indicator>
  </RadioGroupPrimitive.Item>
));
ColorPickerItem.displayName = 'ColorPickerItem';

export {ColorPicker};
